import { css } from 'lit';
export default css `
  wui-icon-box {
    height: var(--wui-icon-box-size-xl);
    width: var(--wui-icon-box-size-xl);
  }
`;
//# sourceMappingURL=styles.js.map